import React, { useEffect, useState } from 'react';
import { RichText, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import OTPField from '../../OTPField/';
import Loader from '../../Loader/';
// import { OTPContext } from 'components/IBANGeneratorComponent/context';
import { useContext } from 'react';
import { OTPContext } from '../../context';

const changeNumberToTwoDigits = (num) =>
  num.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });

const StepTwo = ({
  verificationCodeExpiredErrorMessage,
  error,
  setError,
  setStep,
  recaptchaValue,
  setRecaptchaValue,
  title,
  otpSubHeading,
  otpVerificationCode,
  otpDidNotReceiveText,
  otpSendNewCodeText,
  accountNumber,
  t,
  timeout,
  otpVerifyEndpoint,
  otpGenerateEndpoint,
  generalErrorMessage,
  limitationNumber,
  limitationMessage,
  otpGenerateErrorMessage,
  timeoutErrorMessage,
  // otpRegenerateWaitingTime,
  // ibanNumber,
  // setIbanNumber,
}) => {
  const { setIbanNumber } = useContext(OTPContext);
  // Component states
  const [loading, setLoading] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [output, setOutput] = useState('--:--');
  const [value, setValue] = useState(['', '', '', '', '', '']);
  const [attempts, setAttempts] = useState(0);
  const [newCode, setNewCode] = useState(0);
  const [userCanSendState, setUserCanSendState] = useState(false);
  const accountNumberMin = 10;

  // Conditional rendering
  const shouldRenderTitle = !!title?.value;
  const shouldRenderOtpSubHeading = !!otpSubHeading?.value;
  const shouldRenderOtpVerificationCode = !!otpVerificationCode?.value;

  // Recaptcha key
  const context = useSitecoreContext(); // We need to get the recaptcha key from sitecore context
  const recaptchaKey = context?.sitecoreContext?.siteConfigurations?.googleReCAPTCHAKey || '';
  const shouldRenderRecaptcha = recaptchaKey !== '';
  const [forceDisableMessage, setForceDisableMessage] = useState('');

  const LOCAL_STORAGE_ATTEMPT_KEY = 'otpAttemptsStep';
  const LOCAL_STORAGE_DISABLE_OTP_KEY = 'disableGenerateOtpButton';
  const LOCAL_STORAGE_OTP_TIMER_KEY = 'otpDateCanGenerate';

  const [forceDisable, setForceDisable] = useState(false);

  const getAttemptsStorage = () => {
    if (typeof localStorage !== 'undefined') {
      const attempts = parseInt(
        localStorage.getItem(LOCAL_STORAGE_ATTEMPT_KEY) || limitationNumber?.value
      );
      return attempts;
    }
  };
  const setAttemptsStorage = (attempts) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LOCAL_STORAGE_ATTEMPT_KEY, attempts);
    }
  };

  const decrementAttemptsStorage = (dateBlockUntil, numberofRemainingRetries) => {
    // debugger;
    if (typeof localStorage !== 'undefined') {
      let attempt = getAttemptsStorage();
      const newAttemptStorage =
        typeof numberofRemainingRetries !== 'undefined' && numberofRemainingRetries !== attempt - 1
          ? numberofRemainingRetries
          : attempt - 1;
      if (newAttemptStorage === -1) {
        showError(`${limitationMessage?.value}`);
        if (!!dateBlockUntil) {
          localStorage.setItem(LOCAL_STORAGE_DISABLE_OTP_KEY, dateBlockUntil);
        }

        if (new Date() >= dateBlockUntil) {
          setAttemptsStorage(limitationNumber?.value);
          localStorage.removeItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
          hiddeError();
        }
      } else {
        setAttemptsStorage(newAttemptStorage);
      }
    }
  };

  const showError = (message, disableBtn = true) => {
    setForceDisable(disableBtn);
    setForceDisableMessage(message);
    // show error
    // disable button
  };

  const hiddeError = () => {
    // console.log(' hiddeError');
    setForceDisable(false);
    setForceDisableMessage('');
  };
  const userCanSend = () => {
    // console.log('method userCanSend ');
    if (typeof localStorage !== 'undefined') {
      const disableGenerateOtpButtonValue = localStorage.getItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
      let disabledUntil = new Date(disableGenerateOtpButtonValue);
      // console.log('disabledUntil', disabledUntil);
      if (!!disableGenerateOtpButtonValue) {
        if (new Date() <= disabledUntil) {
          // still frozen we show error and prevent next step
          showError(`${limitationMessage?.value}`);
          // console.log('userCanSend showError');

          setUserCanSendState(false);
          return false;
        } else {
          // frozen time is reached and we need to clear the local storage and allow the user to send again
          localStorage.removeItem(LOCAL_STORAGE_DISABLE_OTP_KEY);
          setAttemptsStorage(limitationNumber?.value);
          hiddeError();
          setUserCanSendState(true);
          return true;
        }
      } else {
        setUserCanSendState(true);
        return true;
      }
    }
    setUserCanSendState(false);
    return false;
  };

  // we want to ouput the accountNumber differently
  let formattedAccountNumber = accountNumber.substr(0, 2);
  for (let i = 0; i < accountNumber?.length - 5; i++) {
    formattedAccountNumber += '*';
  }
  formattedAccountNumber += accountNumber.substr(accountNumber.length - 3);

  // This side effect will run function that runs a counter
  useEffect(() => {
    // console.log('useEffect render ');
    setBtnDisabled(false);
    let elapsedTime = timeout?.value || 0;
    const x = setInterval(() => {
      const dueDate = new Date();
      dueDate.setSeconds(dueDate.getSeconds() + elapsedTime);
      const now = new Date().getTime();
      const distance = dueDate.getTime() - now;
      if (distance < 0) {
        clearInterval(x);
        setBtnDisabled(true);
        return;
      }
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setOutput(`${changeNumberToTwoDigits(minutes)}:${changeNumberToTwoDigits(seconds)}`);
      elapsedTime--;
    }, 1000);
    return () => {
      clearInterval(x);
    };
  }, [newCode]);

  // Verify Otp listener
  const verifyOtp = async () => {
    // console.log('verifyOtp render ');
    if (btnDisabled) return;
    setBtnDisabled(true);
    setError((prev) => {
      prev[1].status = false;
      prev[1].msg = '';
      return prev;
    });
    if (otpValue.length < 6) {
      setError((prev) => {
        prev[1].status = true;
        prev[1].msg = generalErrorMessage?.value || '';
        return prev;
      });
      return;
    }
    try {
      const verifySMS = await axios.post(
        otpVerifyEndpoint?.value,
        { 
          reference: accountNumber,
          otpValue: otpValue,
          recaptchaToken: recaptchaValue 
        }
        // { withCredentials: true }
      );
      // console.log(verifySMS?.data);
      setBtnDisabled(false);
      if (verifySMS?.data?.output?.verified === '0') {
        setError((prev) => {
          prev[1].status = true;
          prev[1].msg = generalErrorMessage?.value || '';
          return prev;
        });
        const limitation = limitationNumber?.value;
        if (attempts === limitation - 1) {
          // we should read it on the page load also to check if we have it we disable to button for the right amount
          setBtnDisabled(true);
          // console.log('setBtnDisabled attempts === limitation - 1');
          setError((prev) => {
            prev[1].status = true;
            prev[1].msg = limitationMessage?.value;
            return prev;
          });
        }
        setAttempts((prev) => ++prev);

        if (typeof window !== 'undefined' && window?.grecaptcha?.reset) {
          // console.log('recaptcha reset', limitation - 1);
          if (attempts < limitation - 1) {
            window.grecaptcha.reset();
            setBtnDisabled(true);
          }
        }
      } else {
        if (!!verifySMS?.data?.output?.iBANNumber) {
          setIbanNumber(verifySMS?.data?.output?.iBANNumber);
        }
        setStep(2);
      }
    } catch (err) {
      console.log('Error verifying otp', err);
    }
  };

  // Recaptcha listener
  const onRecaptchaChange = (value) => {
    // console.log('onRecaptchaChange');
    setRecaptchaValue(value);
    setBtnDisabled(false); // enable button when refreshing recaptcha

    // console.log('setBtnDisabled onRecaptchaChange');
    const limitation = limitationNumber?.value;
    // disable the continue button only when the number of max retires is reached, or time is reached
    if (attempts >= limitation || output === '00:00') {
      // console.log('output', output);
      setBtnDisabled(true);
      // console.log(`${attempts}`);
      // console.log(`${limitation}`);
      // console.log(`${output}`);
      // console.log('setBtnDisabled onRecaptchaChange attempts >= limitation || output');
    }
    // console.log('attempts', attempts);
    // console.log('limitationNumber?.value', limitationNumber?.value);
  };

  // Send new Otp code
  const sendNewCode = async () => {
    try {
      if (userCanSend()) {
        // if (recaptchaValue === null) return;
        // We generate the Otp
        const generateSMS = await axios.get(
          otpGenerateEndpoint?.value?.replace('{reference}', accountNumber)
        );
        let dateBlockUntil = null;

        const attempts = getAttemptsStorage();
        // debugger;

        if (
          attempts === 0 ||
          generateSMS?.data?.output?.numberofRemainingRetries === 0 ||
          generateSMS?.data?.output?.errorCode === 'LimitReached'
        ) {
          if (generateSMS?.data?.output?.success !== '1') {
            // debugger;
            if (attempts === 0) {
              showError(generateSMS?.data?.output?.errorMessage, false);
              // console.log('sendNewCode 1 showError');
            } else {
              showError(generateSMS?.data?.output?.errorMessage);
              // console.log('sendNewCode 2 showError');
            }
          }

          dateBlockUntil = new Date(); // new Date(parseInt(dateString.slice(6, -2)));
          dateBlockUntil.setMinutes(
            dateBlockUntil.getMinutes() + generateSMS?.data?.output?.oTPLimitResetDurationInMinutes // add oTPLimitResetDurationInMinutes
          );

          localStorage.setItem(LOCAL_STORAGE_DISABLE_OTP_KEY, dateBlockUntil);
        }
        if (generateSMS?.data?.output?.errorCode !== 'TimeElapsed') {
          decrementAttemptsStorage(
            dateBlockUntil,
            generateSMS?.data?.output?.numberofRemainingRetries
          );
          // console.log('attempts:', attempts);
          // debugger;
        } else {
          if (generateSMS?.data?.output?.success !== '1') {
            // debugger;
            // console.log('sendNewCode 3 showError');
            // showError(`${timeoutErrorMessage?.value}`);

            const OTPDateBlockUntil = localStorage.getItem(LOCAL_STORAGE_OTP_TIMER_KEY);
            const OTPDateBlockUntilDate = new Date(OTPDateBlockUntil);
            const diffInSeconds = Math.ceil(
              Math.abs(new Date().getTime() - OTPDateBlockUntilDate.getTime())
            );

            console.log('diffInSeconds', diffInSeconds);

            // showError(`${timeoutErrorMessage?.value}`);
            let msg = timeoutErrorMessage?.value?.replaceAll('${0}', diffInSeconds);
            showError(msg);
          }
        }
        setAttempts(0);
        setNewCode((prev) => ++prev);
        setError((prev) => {
          prev[1].status = false;
          prev[1].msg = '';
          return prev;
        });
        setValue(['', '', '', '', '', '']);
        setRecaptchaValue(null);
        setOtpValue('');
        if (typeof window !== 'undefined' && window?.grecaptcha?.reset) {
          window.grecaptcha.reset();
        }
      }
    } catch (err) {
      console.log('Error in generating a new OTP', err);
    }
  };

  // useEffect(() => {
  //   console.log('btnDisabled', btnDisabled);
  //   // console.log('recaptchaValue', recaptchaValue);
  //   console.log('otpValue.length', otpValue.length);
  // }, [btnDisabled, otpValue, recaptchaValue]);

  // In case the account number or recaptcha isn't there
  if (accountNumber.length < accountNumberMin) return null;

  if (loading) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  } else {
    return (
      <div className="row">
        <div className="col-12 col-lg-6 left-side">
          {shouldRenderTitle && <Text tag="h3" field={title} />}
          {shouldRenderOtpSubHeading && (
            <RichText
              className="otp-sub-heading"
              tag="p"
              field={{
                value: otpSubHeading?.value?.replace('{accountNumber}', formattedAccountNumber),
              }}
            />
          )}
          {shouldRenderOtpVerificationCode && (
            <Text tag="p" className="otp-verification-code" field={otpVerificationCode} />
          )}
          <div className={clsx('otp-final', error[1].status && 'otp-final-error')}>
            <div className="otp-fields-container">
              <OTPField
                value={value}
                setValue={setValue}
                setError={setError}
                error={error[1].status}
                setOtpValue={setOtpValue}
              />
              {error[1].status && <div className="otp-error">{error[1].msg}</div>}
            </div>
            {shouldRenderRecaptcha && (
              <div className="recaptcha">
                <ReCAPTCHA sitekey={recaptchaKey} onChange={onRecaptchaChange} />
              </div>
            )}
            <button
              className={clsx(
                'button button-contained-primary continue-btn',
                (btnDisabled || recaptchaValue === null || otpValue.length < 6) && 'disabled-btn'
              )}
              onClick={verifyOtp}
            >
              {`${t('continue')} (${output})`}
            </button>

            {output === '00:00' ? (
              <div className="generic-error">{verificationCodeExpiredErrorMessage?.value}</div>
            ) : null}
            <div className="otp-resend">
              <span className="otp-receive">{otpDidNotReceiveText?.value || ''}</span>
              &nbsp;
              <span
                className={clsx(
                  'otp-new-code',
                  // recaptchaValue === null && !btnDisabled && 'disabled'
                  output !== '00:00' ||
                    (attempts >= limitationNumber?.value - 1 && userCanSendState && !forceDisable)
                    ? 'disabled'
                    : ''
                  // output !== '00:00' ? 'disabled' : ''
                )}
                onClick={sendNewCode}
              >
                {' '}
                {otpSendNewCodeText?.value || ''}
              </span>
            </div>

            {!!forceDisableMessage && forceDisableMessage !== '' && (
              <div className="generic-error">{forceDisableMessage}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default StepTwo;
